import { domel } from '@easydata/ui';
import { browserUtils } from '../../utils/browser_utils';
var BaseElementRenderer = /** @class */ (function () {
    function BaseElementRenderer(slot) {
        this.element = slot || domel('div').toDOM();
    }
    BaseElementRenderer.prototype.refresh = function () {
        this.render();
    };
    BaseElementRenderer.prototype.render = function (isEditMode) {
        var _this = this;
        if (isEditMode === void 0) { isEditMode = false; }
        this.labelElement = this.renderLabelElement();
        domel(this.element)
            .html('')
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .addChildElement(this.labelElement);
        if (this.isEditable()) {
            this.renderEditor();
            if (isEditMode) {
                setTimeout(function () { return _this.showEditor(); }, 50);
            }
        }
        return this.element;
    };
    BaseElementRenderer.prototype.isEditable = function () {
        return true;
    };
    BaseElementRenderer.prototype.renderLabelElement = function () {
        var _this = this;
        var displayedText = this.getLabelText();
        if (this.isEditable()) {
            return domel('a')
                .attr('href', 'javascript:void(0)')
                .title(displayedText)
                .text(displayedText)
                .on('click', function (ev) {
                ev.preventDefault();
                _this.showEditor();
                return false;
            })
                .toDOM();
        }
        else {
            return domel('span')
                .title(displayedText)
                .text(displayedText)
                .toDOM();
        }
    };
    BaseElementRenderer.prototype.getClassesToAdd = function () {
        return '';
    };
    BaseElementRenderer.prototype.getLabelText = function () {
        return this.getEmptyText();
    };
    BaseElementRenderer.prototype.getEmptyText = function () {
        return '<empty>';
    };
    return BaseElementRenderer;
}());
export { BaseElementRenderer };
//# sourceMappingURL=base_element_renderer.js.map